<template>
  <v-dialog v-model="dialog" width="600px" :fullscreen="$vuetify.breakpoint.smAndDown" scrollable>
    <v-card>
      <v-card-title class="blue darken-4 white--text text-uppercase"
        >Sửa {{ grade.title }}
        <v-spacer />
        <v-icon color="white" @click="cancel">close</v-icon>
      </v-card-title>
      <v-card-text>
        <v-divider></v-divider>
        <GradeForm :grade="grade" ref="form" />
      </v-card-text>
      <v-divider></v-divider>
      <v-card-actions class="d-flex justify-space-between pa-6">
        <v-btn class="text-none text-uppercase" outlined @click="cancel">Huỷ</v-btn>
        <v-btn color="primary text-none text-uppercase" elevation="0" :loading="loading" @click="save">Lưu</v-btn>
      </v-card-actions>
    </v-card>
  </v-dialog>
</template>
<script>
import GradeForm from '@/components/basic/form/GradeForm.vue'
import { mapActions } from 'vuex'

export default {
  components: {
    GradeForm,
  },
  props: {
    state: Boolean,
    grade: { type: Object, default: () => {} },
  },
  data() {
    return {
      dialog: false,
      loading: false,
    }
  },
  methods: {
    ...mapActions('grade', ['updateGrade']),
    async save() {
      if (!this.$refs.form.validate()) return
      try {
        this.loading = true
        const data = this.$refs.form.getData()
        await this.updateGrade({ id: this.grade.id, ...data })
        this.$alert.updateSuccess()
        this.dialog = false
      } catch (error) {
        this.$alert.updateError()
      } finally {
        this.loading = false
      }
    },
    cancel() {
      this.dialog = false
      this.$refs.form.resetDefault()
    },
  },
  watch: {
    state() {
      this.dialog = true
    },
  },
}
</script>
